<template>
    <SubmitButton :loading="loadings.restartJob" classes="btn btn-sm btn-info text-center btn-block" @click.prevent="restartJob">
        <slot/>
    </SubmitButton>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import SubmitButton from "@/components/shared/Forms/SubmitButton";
import Job from "@/classes/Job";

export default {
    name: "RestartJobButton",
    components: { SubmitButton },
    props: {
        job: {
            type: Job,
            required: true,
        },
    },
    data() {
        return { loadings: { restartJob: false } };
    },
    methods: {
        ...mapActions("order", { updateOrder: "updateOrder" }),
        confirmRestartJob() {
            return Swal.fire({
                title: this.$t("RestartJobButton.areYouSure"),
                text: this.$t("RestartJobButton.jobWillRestart"),
                icon: "warning",
                animation: false,
                showCancelButton: true,
                cancelButtonText: this.$t("RestartJobButton.cancel"),
            });
        },
        async restartJob() {
            try {
                const { isConfirmed } = await this.confirmRestartJob();
                if (isConfirmed) {
                    this.loadings.restartJob = true;
                    const { orderId, productId, _id: jobId } = this.job;
                    const { data } = await this.$gutenbergOneRobotAPI.patchJob(orderId, productId, jobId, { status: "pending" });
                    this.updateOrder(data);
                    this.$toasted.success(this.$t("RestartJobButton.jobRestarted"), { icon: "check" });
                }
            } catch (e) {
                this.$error.display(e);
            } finally {
                this.loadings.restartJob = false;
            }
        },
    },
};
</script>

<style scoped>

</style>